import find from 'lodash/find';
import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';

const sortByRank = (starts = []) =>
  sortBy(
    starts.filter(start => start.ranking != null),
    [start => start.ranking.weight],
  );

export const getRankedStarts = starts =>
  groupBy(sortByRank(starts), start => start.ranking.category);

export const findStartByLegStartNumber = (round, leg_number, start_number) =>
  find(round.starts, { leg_number: leg_number, start_number });

export const findStartByRaceStartNumber = (round, race_id, start_number) =>
  find(round.starts, { race_id, start_number });
